var map = {
	"./commom/menu.js": 1006,
	"./commom/select-data.js": 1007,
	"./commom/user-info.js": 1008,
	"./goods/brand-list.js": 1093,
	"./goods/categories.js": 1094,
	"./goods/details.js": 1095,
	"./goods/good-list.js": 1096,
	"./goods/refund-list.js": 1097,
	"./goods/return-list.js": 1098,
	"./index.js": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;